import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import ApprovalGateway from '~apis/approval';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TUpdateGoldConversionStatusReduxParams } from '~types/feat/approval';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { GoldConversionStatusEnum } from '~utils/enums';

export default function* watchUpdateGoldConversionStatus(api: ApprovalGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalUpdateGoldConversionStatusAttempt', handleUpdateGoldConversionStatus, api);
}

function* handleUpdateGoldConversionStatus(api: ApprovalGateway, data: PayloadAction<TUpdateGoldConversionStatusReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        id,
        status,
    } = data.payload;

    const response = yield* call([api, api.updateGoldConversionStatus], {
        authToken,
        id,
        status,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalUpdateGoldConversionStatusFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const successMessage = status === GoldConversionStatusEnum.Approved
            ? SuccessMessages.ApprovalApproveGoldConversionSuccess
            : status === GoldConversionStatusEnum.Rejected
                ? SuccessMessages.ApprovalRejectGoldConversionSuccess
                : '';

        yield put(combinedActions.approvalSetConfirmUpdateGoldConversionStatusModalIsOpen(false));
        yield put(combinedActions.approvalGetPendingGoldConversionListingAttempt());
        yield put(combinedActions.approvalUpdateGoldConversionStatusSuccess());

        toast.success(successMessage);
    }
}
